import { boot } from 'quasar/wrappers'
import { AddressbarColor } from 'quasar'

export default boot(() => {
  AddressbarColor.set('#1D1D1D')
})
